module.exports = require('./_hide');


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/core-js/library/modules/_redefine.js
// module id = 443
// module chunks = 0